import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import StopIcon from '@material-ui/icons/Stop';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import FastForwardIcon from '@material-ui/icons/FastForward';
import FastRewindIcon from '@material-ui/icons/FastRewind';

import Slider from '@material-ui/lab/Slider';
// import LensIcon from '@material-ui/icons/LensOutlined';
import PanoramaVertical from '@material-ui/icons/PanoramaVertical';

const styles = theme => ({
  card: {
    // display: 'flex',
    width: "100%"
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    // width: "100%",
  },
  content: {
    flex: '1 0 auto',
  },
  cover: {
    width: '100%',
  },
  controls: {
    width: '100%',
    display: 'flex',
    // alignItems: 'center',
    justifyContent: 'center',
    // paddingLeft: theme.spacing.unit * 3 ,
    // paddingBottom: theme.spacing.unit,
  },
  playIcon: {
    height: 38,
    width: 38,
  },
  slider: {
    padding: '22px 0px',
  },
  thumbIcon: {
    borderRadius: '50%',
  },
  thumbIconWrapper: {
    backgroundColor: '#fff',
  },
});

class MediaControlCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      isPlay: true,
    }; 
    // this.handleChange = this.handleChange.bind(this);
    // this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSlideChange = (event, value) => {
    console.clear('media value:', value);
    // this.setState({ value });
    this.props.click(value);
  };

  handlePlayStop = () => {
    let boo = false;
    if (this.state.isPlay) {
      boo = false;
      this.props.MediaControlChange(5);
    } else {
      boo = true;
      this.props.MediaControlChange(-5);
    }
    this.setState({ isPlay: boo })

  }



  // function MediaControlCard(props) {
  render() {
    const { classes, theme, max, value } = this.props;
    this.step = 1;
    // let isPlay = this.state.isPlay;

    return (

      <Card className={classes.card}>

        <div className={classes.details}>
          <Slider
            classes={{ container: classes.slider }}
            value={value}
            min={0}
            max={max}
            step={this.step}
            aria-labelledby="slider-image"
            onChange={this.handleSlideChange}
            classes={{
              container: classes.slider,
              thumbIconWrapper: classes.thumbIconWrapper,
            }}
            thumb={<PanoramaVertical style={{ color: '#2196f3' }} />}
          />
        </div>
        <div className={classes.controls}>
          <IconButton aria-label="First" onClick={() => this.props.MediaControlChange(0)}  >
            {theme.direction === 'rtl' ? <SkipNextIcon /> : <SkipPreviousIcon />}
          </IconButton>
          <IconButton aria-label="Previous" onClick={() => this.props.MediaControlChange(-1)} >
            {theme.direction === 'rtl' ? <FastForwardIcon /> : <FastRewindIcon />}
          </IconButton>
          {(this.state.isPlay) ? (
            <IconButton aria-label="Play/pause" onClick={this.handlePlayStop} >
              <PlayArrowIcon className={classes.playIcon} />
            </IconButton>
          ) : (
              <IconButton aria-label="stop" onClick={this.handlePlayStop} >
                < StopIcon className={classes.playIcon} />
              </IconButton>
            )}
          <IconButton aria-label="Next" onClick={() => this.props.MediaControlChange(1)} >
            {theme.direction === 'rtl' ? <FastRewindIcon /> : <FastForwardIcon />}
          </IconButton>
          <IconButton aria-label="Last" onClick={() => this.props.MediaControlChange(9)} >
            {theme.direction === 'rtl' ? <SkipPreviousIcon /> : <SkipNextIcon />}
          </IconButton>
        </div>

      </Card>
    );
  };
}

MediaControlCard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(MediaControlCard);


//  <Typography component="h5" variant="h5">
//               Live From Vehicle
//           </Typography>
//             <Typography variant="subtitle1" color="textSecondary">

//             </Typography>